<template>
    <div>
        <b-modal
            id="lesson-preview"
            :title="modalName"
            size="lg"
            hide-footer
        >
            <div v-if="lesson.video_url">
                <div style="padding:56.25% 0 0 0;position:relative;" class="mb-4">
                    <iframe :src="lesson.video_url" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
                </div>
            </div>
            <div class="ql-snow m-0 p-0" v-if="lesson.text">
                <div class="h5">
                    Conteúdo
                </div>

                <div class="ql-editor" v-html="lesson.text.content"></div>
            </div>
            <div v-if="lesson.files.length > 0" class="">
                <div class="h5 mt-3">
                    Material Complementar
                </div>

                <div class="mb-3 row">
                    <div v-for="(lessonFileItem, key) in lesson.files" :key="lessonFileItem.id" class="col-sm-12 d-flex">
                        <div class="text-muted">
                            <i class="fas fa-file mr-2"></i>
                            {{ lessonFileItem.name }}
                        </div>
                        <div class="ml-3 text-right">
                            <a :href="lessonFileItem.preview" target="_blank">
                                Baixar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            lesson: {
                files: []
            },
        }
    },
    computed: {
        modalName() {
            if (this.lesson) {
                return this.lesson.name;
            }

            return 'Conteúdo da Aula'
        },
    },
    created() {
        this.$root.$on('show-lesson-preview', (lesson) => {
            this.lesson = lesson;
            this.$bvModal.show('lesson-preview');
        });
    }
}
</script>

<style scoped>

</style>
